import React, { useState } from 'react';
import QrReader from 'react-qr-scanner';

// react-qr-scanner's own README documents onScan passing the decoded value
// directly as a string, but this installed version's actual compiled source
// always passes an object shaped {text, ...} instead (confirmed by reading
// its dist/web-worker source) — support both rather than trust either source
// alone, since this is a pre-1.0 alpha dependency.
export const getScanText = (result) => {
  if (result === null || result === undefined) return undefined;
  if (typeof result === 'string') return result;
  return result.text ?? result.Text;
};

const QRTest = (props) => {
  const [data, setData] = useState('No result');
  const [cameraReady, setCameraReady] = useState(false);
  const [cameraError, setCameraError] = useState(false);
  const handleScan = (result) => {
    if (result !== null && result !== undefined) {
      props.onHandleScan(result);
      setData(getScanText(result));
    }
  };
  const handleLoad = () => {
    // Camera stream loaded successfully — reveal the view.
    setCameraReady(true);
  };
  const handleError = (err) => {
    console.error(err);
    // Camera unavailable / permission denied — keep the scanner hidden.
    setCameraError(true);
  };

  // Reveal only once the camera has actually loaded (and no error). The reader
  // stays mounted-but-hidden until then so it never flashes on into an error.
  const show = cameraReady && !cameraError;

  return (
    <>
      {!cameraError && (
        <div style={{ display: show ? 'block' : 'none' }}>
          <QrReader onLoad={handleLoad} onError={handleError} onScan={handleScan} style={{ width: '100%' }} />
        </div>
      )}
      {show && <p style={{ margin: '8px 0' }}>{data}</p>}
    </>
  );
};

// class QrContainer extends Component {
//     constructor(props){
//         super(props)
//         this.state = {
//             result: "Hold Qr Code Steady and Clear to Scan",
//         }
//         this.handleScan = this.handleScan.bind(this)
//     }

//     handleScan(result)
//     {
//         this.setState({
//             result: data
//         })
//     }
//     handleError(err)
//     {
//         console.error(err);
//     }
//     render(){
//         const previewStyle =
//         {
//             height: 700,
//             width: 1000,
//             display: 'flex',
//             "justify-content": "center"
//         }

//         const camStyle = {
//             display: 'flex',
//             justifyContent: "center",
//             marginTop: '-50px'
//         }
//         const textStyle =
//         {
//             fontSize: '30px',
//             "text-align": 'center',
//             marginTop: '-50px'
//         }

//         return(
//             <React.Fragment>
//                 <div style = {camStyle} >
//                     <QrReader
//                         delay={100}
//                         style={previewStyle}
//                         onError={this.handleError}
//                         onScan={this.handleScan}
//                     />
//                 </div>
//                 <p style={textStyle}>
//                     {this.state.result}
//                 </p>
//             </React.Fragment>
//         )
//     }
// }

export default QRTest;
// export default QrContainer;
